<template>
  <v-dialog v-model="dialog" width="750" height="400" persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="headline orange lighten-3 d-flex flex-row">
        <v-layout align-center>
          <v-chip>{{statusLabel}}</v-chip>
          <v-flex grow>{{repair.showStreetAddress}}</v-flex>
          <v-spacer />
          <v-chip v-if="repair.status === 0" @click="confirm('Confirm the task', '', confirmTask)">
            <v-icon color="primary">done_outline</v-icon>Confirm
          </v-chip>
          <v-chip v-if="repair.status === 0" @click="confirm('Cancel the task', '', cancelTask)">
            <v-icon color="primary">cancel</v-icon>Cancel
          </v-chip>
          <v-chip v-if="repair.status === 1" @click="confirm('Cancel the task', '', cancelTask)">
            <v-icon color="primary">cancel</v-icon>Cancel
          </v-chip>
          <v-chip v-if="repair.status === 9" @click="confirm('Close the case', '', closeCase)">
            <v-icon color="secondary">done_outline</v-icon>Close
          </v-chip>
          <v-chip v-if="repair.status === 10" @click="confirm('Reopen the case', '', reopenCase)">
            <v-icon color="secondary">keyboard_return</v-icon>Reopen
          </v-chip>
          <v-btn flat icon class="align--right" @click.stop="accept('OK')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>

      <v-card-title>
        <v-flex md9 pr-3>
          <v-textarea
            label="Description"
            auto-grow
            outlined
            rows="2"
            row-height="15"
            v-model="description"
            placeholder="description of the maintenance"
          >
            <template v-slot:append>
              <v-icon :disabled="repair && repair.description === description" v-on:click="saveDescription()">save</v-icon>
            </template>
          </v-textarea>
        </v-flex>
        <v-flex md3 text-xs-right class="d-flex flex-row justify-end">
          <v-menu
            :nudge-right="4"
            lazy
            transition="scale-transition"
            offset-y
            :close-on-content-click="true"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="repair.timestamp | moment('D/MM/YYYY')"
                label="Due Date"
                readonly
                append-icon="event"
                v-on="on"
                style="width: 70px;"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="due_date"
              no-title
              ref="date_picker"
            ></v-date-picker>
          </v-menu>
        </v-flex>

      </v-card-title>

      <v-card-title>
        <v-layout row class="mb-2" wrap>
          <v-flex sm12 md4>
            <h2 class="title">
              <v-icon color="blue">house</v-icon>Owner
            </h2>
            <v-divider class="my-2 primary" />
            <v-list dense v-if="repair.house">
              <v-chip>
                <v-icon color="primary">person</v-icon>{{repair.house.owner_firstname + ' ' + repair.house.owner_lastname}}
              </v-chip>
              <v-chip>
                <v-icon color="primary">phone</v-icon>{{repair.house.owner_phone}}
              </v-chip>
              <v-chip>
                <v-icon color="primary">email</v-icon>{{repair.house.owner_email}}
              </v-chip>
              <v-divider class="my-1 primary" />
              <v-chip :class="{ disabled: repair.status !== 0 }" @click.stop="repair.status === 0 && confirm('Sending notification to owner', '', emailNotification)">
                <v-icon color="red">email</v-icon>Email notification
              </v-chip>
              <v-chip :class="{ disabled: repair.status !== 1, selected: owner_fix }" @click.stop="repair.status === 1 && confirm('Owner\'s response', 'Owner says he(she) will fix it alone', () => owner_fix = true)">
                <v-icon color="primary">attribution</v-icon>Owner will fix it
                <v-icon color="primary" right v-if="owner_fix">task_alt</v-icon>
              </v-chip>
              <v-chip :class="{ disabled: repair.status !== 1, selected: !owner_fix }" @click.stop="repair.status === 1 && confirm('Owner\'s response', 'Owner asks us to fix it', () => owner_fix = false)">
                <v-icon color="primary">handyman</v-icon>Asks us to fix it
                <v-icon color="red" right v-if="!owner_fix">task_alt</v-icon>
              </v-chip>
            </v-list>
          </v-flex>
          <v-flex sm12 md4>
            <h2 class="title">
              <v-icon color="green">person</v-icon>Tenant
            </h2>
            <v-divider class="my-2 green" />
            <v-list dense>
              <v-chip>
                <v-icon color="green">person</v-icon>{{tenant.name}}
              </v-chip>
              <v-chip>
                <v-icon color="green">phone</v-icon>{{tenant.phone}}
              </v-chip>
              <v-chip>
                <v-icon color="green">email</v-icon>{{tenant.email}}
              </v-chip>
              <v-divider class="my-1 primary" />
              <v-chip class="ma-2" :class="{ selected: tenantAdmitFixed }" @click.stop="repair.status === 1 && confirm('To finish the fix', 'Tenant admits the issue fixed', tenantAdmitFix)">
                <v-icon color="green">thumb_up</v-icon>It is fixed
              </v-chip>
              <v-chip @click.stop="confirm('Tenant\'s feedback', 'Tenant says the issue is still there')">
                <v-icon color="green">sentiment_very_dissatisfied</v-icon>Not fixed yet
              </v-chip>
              <v-chip @click.stop="confirm('Tenant\'s feedback', 'Tenant says: ...')">
                <v-icon color="green">mood_bad</v-icon>Other comments
              </v-chip>
            </v-list>
          </v-flex>
          <v-flex sm12 md4>
            <h2 class="title">
              <v-layout>
                <v-icon color="secondary">handyman</v-icon>Performer
              </v-layout>
            </h2>
            <v-divider class="my-2 secondary" />
            <v-list dense v-if="!owner_fix">
              <v-layout style="height: 40px;">
                <v-icon color="secondary">person</v-icon>
                <v-select item-text="text" key="text" item-value="value"
                  :items="handymenItems"
                  label="Choose an handyman"
                  v-model="repair.assignee"
                  solo flat hide-details outlined
                ></v-select>
              </v-layout>
              <template v-if="selectedHandyman">
                <v-chip>
                  <v-icon color="secondary">phone</v-icon>{{selectedHandyman.phone}}
                </v-chip>
                <v-chip>
                  <v-icon color="secondary">email</v-icon>{{selectedHandyman.email}}
                </v-chip>
                <v-divider class="my-1 primary" />
                <v-chip :class="{ disabled: repair.status >= 8, selected: handymanConfirm === 'billOnOwner' }" @click.stop="repair.status < 9 && confirm('Handyman confirms', 'Bill on owner\'s', billOnOwner)">
                  <v-icon color="secondary">house</v-icon>Bill on owner's
                </v-chip>
                <v-chip :class="{ disabled: repair.status >= 8, selected: handymanConfirm === 'billOnTenant' }" @click.stop="repair.status < 9 && confirm('Handyman confirms', 'Bill on tenant\'s', billOnTenant)">
                  <v-icon color="secondary">person</v-icon>Bill on tenant's
                </v-chip>
                <v-chip :class="{ disabled: repair.status >= 8, selected: handymanConfirm === 'handymanRefuses' }" @click.stop="repair.status < 9 && confirm('Handyman refuses', 'Handyman explains that...', handymanRefuses)">
                  <v-icon color="secondary">sentiment_very_dissatisfied</v-icon>Cannot fix
                </v-chip>
              </template>
            </v-list>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card-text style="padding: 0 20px;" class="container scroll">
        <v-divider class="my-1 primary" />
        <v-flex v-if="repair">
          <v-list v-for="note in repair.note" :key="note.id" class="repair">
            <v-chip style="width: 240px">
              <v-icon color='red'>notes</v-icon>
              {{note.account.account}}@{{note.created_at}}
            </v-chip>
            <v-chip style="width: 400px">
              <span>{{note.message}}</span>
            </v-chip>
          </v-list>
        </v-flex>
      </v-card-text>
      <v-divider />
      <v-card-actions class="status-action-group">
      </v-card-actions>
    </v-card>
    <ConfirmDialog ref="dlg"/>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import repairStatus from '@/helpers/repair_status';
import ConfirmDialog from '@/components/ConfirmDialog';
import ownerNotification from '@/template/repair/ownerNotification';

export default {
  name: 'RepairTaskDialog',
  components: {
    ConfirmDialog,
  },
  data: () => ({
      dialog: false,
      busy: false,
      newNote: '',
      description: '',
      due_date: null,
      statusMap: [{
        status: repairStatus.Proposed,
        label: 'Proposed',
      }, {
        status: repairStatus.Assigned,
        label: 'Assigned',
      }, {
        status: repairStatus.Performing,
        label: 'Performing',
      }, {
        status: repairStatus.Reporting,
        label: 'Reporting',
      }, {
        status: repairStatus.Performed,
        label: 'Performed',
      }, {
        status: repairStatus.Finished,
        label: 'Finished',
      }, {
        status: repairStatus.Archived,
        label: 'Archived',
      }],
      summary: {
        selectedHandyman: '',
        owner_fix: false,
        tenantAdmitFixed: false,
        handymanConfirm: false,
      },
  }),

  watch: {
    due_date(val, oldValue) {
      this.update({ id: this.repair.id, timestamp: moment(val).unix()})
    },
    dialog(val, oldValue) {
      if (val) {
        this.description = this.repair.description;
      }
    },
  },
  computed: {
    ...mapGetters({
      repair: 'Repairs/getSelected',
      handymen: 'Repairs/getHandymen',
      account: 'User/getUser',
    }),
    handymenItems() {
      return this.handymen.map(item => ({
        text: item.account,
        value: item,
      }))
    },
    tenant() {
      const lease = this.activeLease(this.repair.house_id);
      if (lease && lease.tenant && lease.tenant.length > 0) {
        const tenant = lease.tenant[0]
        return {
          name: tenant.tenant_name,
          email: tenant.tenant_email,
          phone: tenant.tenant_phone
        }
      }
      return {
        name: 'Unknown',
        email: 'Not registered',
        phone: 'Not registered',
      }
    },
    leftDays() {
      const now = moment();
      const leaseCheckoutDate = moment(this.repair.timestamp, 'YYYY-MM-DD');
      const days = leaseCheckoutDate.diff(now, 'days')
      return days;
    },
    statusLabel() {
      const map = this.statusMap.find(map => map.status === this.repair.status);
      console.log({map, repair: this.repair})
      return map? map.label: 'Unknown';
    },
    owner_fix: {
      get() {
        return this.summary? this.summary.owner_fix: false
      } ,
      set(value) {
        if (this.repair.status >= repairStatus.Performed) {
          return;
        }
        if (!this.summary) {
          this.summary = {}
        }
        this.summary.owner_fix = value;
        this.update({ id: this.repair.id, summary: JSON.stringify(this.summary) })
      }
    },
    // selectedHandyman: {
    //   get() {
    //     console.log('selectedHandyman', this.summary.selectedHandyman)
    //     return this.summary.selectedHandyman
    //   },
    //   set(value) {
    //     this.summary.selectedHandyman = value;
    //     this.update({ id: this.repair.id, summary: JSON.stringify(this.summary) })
    //   }
    // },
    // selectedHandyman: {
    //   get() {
    //     console.log('selectedHandyman', this.repair.assignee)
    //     return this.repair.assignee
    //   },
    //   set(value) {
    //     this.repair.assignee = value
    //     this.repair.assignee_id = value.id;
    //     this.update({ id: this.repair.id, assignee_id: this.repair.assignee_id })
    //     console.log('selectedHandyman', this.repair.assignee)

    //     // this.summary.selectedHandyman = value;
    //     // this.update({ id: this.repair.id, summary: JSON.stringify(this.summary) })
    //   }
    // },
    selectedHandyman() {
      return this.repair.assignee
    },
    tenantAdmitFixed: {
      get() {
        return this.summary.tenantAdmitFixed
      } ,
      set(value) {
        if (this.repair.status >= repairStatus.Performed) {
          return;
        }
        this.summary.tenantAdmitFixed = value;
        this.update({ id: this.repair.id, summary: JSON.stringify(this.summary) })
      }
    },
    handymanConfirm: {
      get() {
        return this.summary.handymanConfirm
      } ,
      set(value) {
        if (this.repair.status >= repairStatus.Performed) {
          return;
        }
        this.summary.handymanConfirm = value;
        this.update({ id: this.repair.id, summary: JSON.stringify(this.summary) })
      }
    },
  },
  async mounted() {
    console.log('mounted', {repair: this.repair, handymen: this.handymen})
    await this.fetchHandymen();
    try {
      this.summary = JSON.parse(this.repair.summary)
    }
    catch(reason) {
    }
  },
  methods: {
    ...mapActions({
      assign: 'Repairs/assign',
      cancel: 'Repairs/cancel',
      finish: 'Repairs/finish',
      close: 'Repairs/close',
      reopen: 'Repairs/reopen',
      comment: 'Repairs/comment',
      update: 'Repairs/update',
      uploadInvoice: 'Repairs/uploadInvoice',
      fetchHandymen: 'Repairs/fetchHandymen',
      sendNotification: 'LeaseList/sendNotification',
      fetchContacts: 'HouseList/fetchContacts',
      activeLease: 'LeaseList/getActiveLease',
    }),
    async emailNotification() {
      this.busy = true;
      console.log({repair: this.repair })
      const email = { to: this.repair.house.owner_email, subject: ownerNotification.subject(this.repair), content: ownerNotification.body(this.repair)};
      await this.sendNotification(email);
      this.busy = false;
      this.assign(this.repair);
    },
    async upload() {
      this.$refs.upload.click()
    },
    async finishUpload(event) {
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        console.log('finishUpload', { target: event.target, file })
        await this.uploadInvoice({repair: this.repair, file})
      }
    },
    async confirmTask() {
      this.assign(this.repair)
      this.accept('OK')
    },
    async cancelTask() {
      this.cancel(this.repair)
      this.accept('OK')
    },
    async reopenCase() {
      this.reopen(this.repair)
      this.accept('OK')
    },
    async closeCase() {
      this.close(this.repair)
      this.accept('OK')
    },
    async saveDescription() {
      this.repair.description = this.description
      this.update({ id: this.repair.id, description: this.description})
    },
    async tenantAdmitFix() {
      this.tenantAdmitFixed = true;
      this.finish(this.repair);
    },
    async billOnOwner() {
      this.handymanConfirm = 'billOnOwner'
    },
    async billOnTenant() {
      this.handymanConfirm = 'billOnTenant'
    },
    async handymanRefuses() {
      this.handymanConfirm = 'handymanRefuses'
    },
    async confirm(title, newNote, actionConfirmed) {
      try {
        newNote = await this.$refs.dlg.open(title, newNote)
        await this.comment({repair: this.repair, note: newNote});
        actionConfirmed(newNote)
      }
      catch(reason) {
      }
    },
    open() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    accept(str) {
      this.dialog = false;
      this.resolve(str);
    },
    refuse(str) {
      this.dialog = false;
      this.reject(str);
    }
  },
}
</script>

<style scoped>
  .avatar {
    padding-right: 0.5rem;
  }
  .status-action-group {
    display: flex;
    flex-direction: line;
    justify-content: center;
    align-items: center;
  }
  .status-action {
    width: 400px;
    padding: 1rem;
    margin: 1rem;
  }
  .contact {
    display: flex;
    flex-direction: row;
  }
  .contact:hover {
    background-color : lightgray;
    border-radius: 5px;
  }
  .repair {
    padding: 0;
  }
  .repair:hover {
    background-color: burlywood;
    border-radius: 5px;
  }
  .scroll {
    overflow-y: scroll
  }
  .v-card {
    display: flex !important;
    flex-direction: column;
  }

  .v-card__text {
    flex-grow: 1;
    overflow: auto;
  }
  .v-card__title {
    padding: 8px 16px;
  }
  .selected {
    background-color: lightseagreen;
  }
  .disabled {
    color: grey;
  }
</style>